import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Add, DescriptionOutlined } from '@mui/icons-material';

interface FormListEmptyProps {
  isFiltered: boolean;
  onClearFilters: () => void;
  onCreate: () => void;
}

export const FormListEmpty: React.FC<FormListEmptyProps> = ({
  isFiltered,
  onClearFilters,
  onCreate,
}) => (
  <Box className="form-list-empty">
    <Box className="form-list-empty-icon" aria-hidden>
      <DescriptionOutlined sx={{ fontSize: 38 }} />
    </Box>
    {/* A filtered empty list is not an empty workspace — offering "create your
        first form" to someone whose only form is filtered out would be wrong. */}
    <Typography className="form-list-empty-title">
      {isFiltered ? 'No forms match these filters' : 'No forms yet'}
    </Typography>
    <Typography className="form-list-empty-text">
      {isFiltered
        ? 'Try a different search term or type.'
        : 'Build a form to collect responses, then share its link or embed it on your site.'}
    </Typography>
    {isFiltered ? (
      <Button
        className="form-list-empty-clear-btn"
        variant="outlined"
        sx={{ mt: 3 }}
        onClick={onClearFilters}
      >
        Clear filters
      </Button>
    ) : (
      <Button
        className="admin-primary-btn"
        variant="contained"
        disableElevation
        sx={{ mt: 3 }}
        startIcon={<Add sx={{ fontSize: 18 }} />}
        onClick={onCreate}
      >
        Create Your First Form
      </Button>
    )}
  </Box>
);
